import { Divider, Flex, forwardRef, FlexProps, Text } from '@chakra-ui/react';

export const NewMessagesIndicator = forwardRef((props: FlexProps, ref) => {
  return (
    <Flex alignItems="center" {...props} ref={ref}>
      <Text color="textAccent" fontSize="xs" whiteSpace="nowrap">
        New messages
      </Text>
      <Divider borderColor="textAccent" ml={1} />
    </Flex>
  );
});
